import React from 'react';
import SearchResultsLayoutProps from "./props";
import Button from '../../private/Button';
import ButtonProps from '../../private/Button/props';
import close from '../../../icons/close.svg';
import './search-results-layout.scss';

function SearchResultsLayout(props: SearchResultsLayoutProps) {
  const { sidebarWidth, sidebarComponent, mainContentComponent, sidebarFooterComponent, overlay, sidebarOpen, device, sidebarTitle, sidebarHeaderComponent } = props;

  const closeSidebar = (e: React.MouseEvent<HTMLElement>) => {
    props.onSidebarClose && props.onSidebarClose(e);
  }

  const isMobile = device === 'mobile';
  const leftColumnOverlay = overlay ? 'search-results-layout__column_overlay' : '';
  const leftColumnOpen = (isMobile || overlay) && !sidebarOpen ? 'search-results-layout__column_hidden' : 'search-results-layout__column_open';

  const leftSidebarClassNames = [
    'search-results-layout__column',
    'search-results-layout__column_left',
    'search-results-layout__column_' + device,
    leftColumnOpen,
    leftColumnOverlay,
    'search-results-sidebar',
  ].join(' ');

  const mainColumnClassNames = [
    'search-results-layout__column',
    'search-results-layout__column_main',
  ].join(' ');

  const width = isMobile ? '100%' : sidebarWidth || '350px';

  return (
    <div className="search-results-layout" data-e2e='search-results-layout'>
      { overlay && sidebarOpen && (
        <div className='search-results-layout__overlay' onClick={ closeSidebar }></div>
      )}
      <div className={ leftSidebarClassNames } style={{ width }}>
        { (isMobile || overlay) && (
          <div className="search-results-sidebar-header search-results-sidebar__header">
            <div className="search-results-sidebar-header__top">
              <h2 className='search-results-sidebar-header__title'>{sidebarTitle || 'Filter'}</h2>
              <Button { ...closeButtonProps() } onClick={ closeSidebar } />
            </div>
            { sidebarHeaderComponent && (
              <div className="search-results-sidebar-header__bottom">
                { sidebarHeaderComponent }
              </div>
            )}
          </div>
        )}
        <div className="search-results-sidebar__content">
          { sidebarComponent }
        </div>
        {(isMobile || overlay) && sidebarFooterComponent && (
          <div className='search-results-sidebar__footer'>{ sidebarFooterComponent }</div>
        )}
      </div>
      <div className={ mainColumnClassNames }>{ mainContentComponent }</div>
    </div>
  );
}

const closeButtonProps = (): ButtonProps => ({
  classNames: {
    icon: true
  },
  Icon: { 
    alt: 'close',
    svg: close,
  }
});

export default React.memo(SearchResultsLayout);